import { newTheme } from '@customerio/pluma-components/css';

export function convertTimeStringToSeconds(timeString: string): number {
  const match = timeString.match(/^([\d.]+)\s*(ms|s)$/);
  if (match == null) {
    throw new Error(`Invalid time string: ${timeString}`);
  }
  const value = Number.parseFloat(match[1]);
  return match[2] === 'ms' ? value / 1000 : value;
}

export const STANDARD_PRODUCTIVE_EASING = newTheme.tokensMeta['motion-easing-standard-productive'].$value;
export const ENTRANCE_PRODUCTIVE_EASING = newTheme.tokensMeta['motion-easing-entrance-productive'].$value;
export const EXIT_PRODUCTIVE_EASING = newTheme.tokensMeta['motion-easing-exit-productive'].$value;
export const FAST_01_DURATION = convertTimeStringToSeconds(newTheme.tokensMeta['motion-duration-fast-01'].$value);
export const FAST_02_DURATION = convertTimeStringToSeconds(newTheme.tokensMeta['motion-duration-fast-02'].$value);
export const MODERATE_01_DURATION = convertTimeStringToSeconds(
  newTheme.tokensMeta['motion-duration-moderate-01'].$value,
);
export const MODERATE_02_DURATION = convertTimeStringToSeconds(
  newTheme.tokensMeta['motion-duration-moderate-02'].$value,
);
export const SLOW_01_DURATION = convertTimeStringToSeconds(newTheme.tokensMeta['motion-duration-slow-01'].$value);
export const SLOW_02_DURATION = convertTimeStringToSeconds(newTheme.tokensMeta['motion-duration-slow-02'].$value);

export const MODERATE_01_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_01_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const MODERATE_01_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_01_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const MODERATE_01_EXIT_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_01_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};
export const FAST_01_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: FAST_01_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const FAST_01_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: FAST_01_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const FAST_01_EXIT_PRODUCTIVE_TRANSITION = {
  duration: FAST_01_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};

export const FAST_02_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: FAST_02_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const FAST_02_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: FAST_02_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const FAST_02_EXIT_PRODUCTIVE_TRANSITION = {
  duration: FAST_02_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};

export const MODERATE_02_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_02_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const MODERATE_02_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_02_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const MODERATE_02_EXIT_PRODUCTIVE_TRANSITION = {
  duration: MODERATE_02_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};

export const SLOW_01_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: SLOW_01_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const SLOW_01_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: SLOW_01_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const SLOW_01_EXIT_PRODUCTIVE_TRANSITION = {
  duration: SLOW_01_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};

export const SLOW_02_STANDARD_PRODUCTIVE_TRANSITION = {
  duration: SLOW_02_DURATION,
  ease: STANDARD_PRODUCTIVE_EASING,
};
export const SLOW_02_ENTRANCE_PRODUCTIVE_TRANSITION = {
  duration: SLOW_02_DURATION,
  ease: ENTRANCE_PRODUCTIVE_EASING,
};
export const SLOW_02_EXIT_PRODUCTIVE_TRANSITION = {
  duration: SLOW_02_DURATION,
  ease: EXIT_PRODUCTIVE_EASING,
};

export const REDUCED_MOTION_TRANSITION = {
  duration: 0,
};
